import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { MatDialog } from '@angular/material';
import { ConfirmdialogComponent } from '../../../common/dialog/confirmdialog.component';
import { ActivityDetailsComponent } from './activity-details/activity-details.component';

@Component({
  selector: 'hybse-admin-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {

  userLogs: any = [];
  showLoader: boolean = true;
  public activityDetails: any[];
  public logType = 'login';
  public logsDetails: any[];
  public idUser: any
  public userName: string;
  public userType: string;
  constructor(private route: Router,
    private _ar: ActivatedRoute,
    private _req: ApirequestService,
    private _utils: UtilityService,
    private _cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private _url: ApiurlsService) {
    this.userName = localStorage.getItem('userName');
    this.userType = localStorage.getItem('userType');

    if (this.userType === 'Admin') {
      this.logType = 'adminLogin';
    }
  }


  ngOnInit() {
    this._ar.params.subscribe(
      (data: any) => {
        this.idUser = data.id;
      });
    this.getUserLogs()
  }

  getUserLogs() {
    let data = {
      data: { idUser: this.idUser }
    }
    data['logType'] = this.logType;
    this._req.fetchApiData(this._url.userLoginDetailsUrl, data).subscribe(
      (data: any) => {
        let resSucc = data.data.userActivity;
        let resErr = data.error;
        if (resSucc != '') {
          this.showLoader = false;
          this.logsDetails = resSucc;

          // this.logsDetails = this._utils.paginatedItems(resSucc, 0, this.pageSize);
          this.pageListOriginal = resSucc;
        }
      });
  }


  /* Pagination */
  pageSize: number = 10;
  paginateLength: number = 0;
  pageListOriginal: any = [];
  paginateEvent: any = {
    length: 100,
    pageIndex: 0,
    pageSize: this.pageSize
  };
  serialNum: number = 1;

  getPaginateItem(e) {
    this.serialNum = e.serialNum;
    this.userLogs = e.items;
    this.paginateEvent = e.pageEvt;
    this._cdr.detectChanges();
  }
  getSerialNum(ind) {
    return this.serialNum + ind;
  }
  initiatePaginate() {
    this.paginateLength = this.pageListOriginal.length;
  }

  activityDetail(id) {
    this.showLoader = true;
    let data = {
      id: id
    }
    this._req.fetchApiData(this._url.activityDetailsUrl, data).subscribe(
      (data: any) => {
        let resSucc = data.data;
        this.activityDetails = data.data;
        let resErr = data.error;
        this.showLoader = false;
        if (resSucc != "") this.activitydetailPopup(resSucc[0]);
      });
  }

  activitydetailPopup(data) {
    const deleteDialog = this.dialog.open(ActivityDetailsComponent, {
      width: '1000px',
      height: '250px',
      data: {
        activityDetail: data
      }
    });
    deleteDialog.afterClosed().subscribe(
      data => {

      }
    );
  }

  tabClick(event): void {

    if (this.userType == 'Admin') {
      if (event.tab['textLabel'] === "Admin Login Details") {
        this.logType = 'adminLogin';
      } else {
        this.logType = 'adminActivity';
      }
    } else {
      if (event.tab['textLabel'] === "Logs Details") {
        this.logType = 'login';
      } else if (event.tab['textLabel'] === "Profile Details") {
        this.logType = 'profile';
      } else {
        this.logType = 'finance';
      }
    }


    this.getUserLogs();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/logs/logs.component.ts